<template>
  <basic-container>
    <div class="search_group">
      <el-input :maxlength="30" v-model="refundNo" size="small" placeholder="输入退款单号"></el-input>
      <el-input :maxlength="30" v-model="orderNo" size="small" placeholder="输入订单编号"></el-input>
      <el-input :maxlength="30" v-model="userAccount" size="small" placeholder="用户账号"></el-input>
      <el-date-picker v-model="searchTime" type="date" value-format="yyyy-MM-dd" size="small" placeholder="申请时间"></el-date-picker>
      <el-select @change="searchAct" v-model="searchStatus" size="small" clearable placeholder="退款状态">
        <el-option label="待处理" :value="1"></el-option>
        <el-option label="已退款" :value="2"></el-option>
        <el-option label="拒绝退款" :value="3"></el-option>
      </el-select>
      <el-button @click="searchAct" icon="el-icon-search" size="small" type="primary">查询</el-button>
      <el-button @click="exportList" v-auth="'memberRefund_export'" icon="el-icon-download" size="small" type="primary">导出</el-button>
    </div>
    <el-table :cell-style="{'text-align':'center'}" :header-cell-style="{'text-align':'center'}" :max-height="tableHeight"
      v-loading="listLoading" element-loading-text="加载中" border :data="tableData">
      <el-table-column fixed prop="refundOrderNo" label="退款单号" width="200"></el-table-column>
      <el-table-column prop="orderId" label="订单编号" width="200"></el-table-column>
      <el-table-column prop="mobile" label="用户账号" width="120"></el-table-column>
      <el-table-column prop="createTime" label="申请时间" width="180"></el-table-column>
      <el-table-column prop="applicationAmount" label="申请金额（元）" width="120"></el-table-column>
      <el-table-column label="退款状态">
        <template slot-scope="scope">{{scope.row.refundReviewStatus | refundStatus}}</template>
      </el-table-column>
      <el-table-column prop="reviewTime" label="处理时间" width="180"></el-table-column>
      <el-table-column prop="reviewUserName" label="处理人"></el-table-column>
      <el-table-column fixed="right" width="200" label="操作">
        <template slot-scope="scope">
          <el-button @click="openDetail(scope.row, 2)" v-if="scope.row.refundReviewStatus==1" v-auth="'memberRefund_handle'" icon="el-icon-info" size="mini" type="text">处理退款</el-button>
          <el-button @click="openDetail(scope.row, 1)" v-if="scope.row.refundReviewStatus!=1" v-auth="'memberRefund_detail'" icon="el-icon-info" size="mini" type="text">退款详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="table_pagination">
      <el-pagination class="app-pagination" background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pageNo" :page-sizes="pageSizeArr" :page-size="pageSize" :layout="paginationLayout" :total="totalEl">
      </el-pagination>
    </div>
    <el-dialog title="退款单信息" :visible.sync="showDetails" append-to-body width="40%">
      <el-form :model="checkItem" size="mini" label-width="110px">
        <el-form-item label="订单编号">
          {{checkItem.orderId}} <el-button v-if="checkItem.orderId" @click="checkDetail(checkItem.orderId)" size="mini" type="text">查看</el-button>
        </el-form-item>
        <el-form-item label="申请账号">{{checkItem.mobile}}</el-form-item>
        <el-form-item label="申请时间">{{checkItem.createTime}}</el-form-item>
        <el-form-item label="申请操作人">{{checkItem.reviewCreateName}}</el-form-item>
        <el-form-item label="退款单号">{{checkItem.refundOrderNo}}</el-form-item>
        <el-form-item label="订单金额">{{checkItem.originalAmount}}元</el-form-item>
        <el-form-item label="退款金额">{{checkItem.applicationAmount}}元</el-form-item>
        <el-form-item label="退款状态">{{checkItem.refundReviewStatus | refundStatus}}</el-form-item>
        <el-form-item label="退款方式">{{checkItem.refundType==1?'退款不退货':checkItem.refundType==2?'退款也退货':''}}</el-form-item>
        <el-form-item label="退款说明">退回原渠道</el-form-item>
        <el-form-item label="退款原因">{{checkItem.content}}</el-form-item>
        <el-form-item label="处理备注">
          <p v-if="checkItem.detailType==1">{{checkItem.reviewContent}}</p>
          <el-input v-if="checkItem.detailType==2" type="textarea" :rows="3" :maxlength="150" resize="none" v-model="refundRemark" placeholder="请输入文字"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showDetails=false" v-if="checkItem.detailType==1" size="small" type="primary" icon="el-icon-circle-check">确定</el-button>
        <el-button @click="changeCheck(2)" v-if="checkItem.detailType==2" v-auth="'memberRefund_handle'" size="small" type="primary" icon="el-icon-circle-check">确认退款</el-button>
        <el-button @click="changeCheck(3)" v-if="checkItem.detailType==2" v-auth="'memberRefund_handle'" size="small" type="danger" icon="el-icon-circle-close">拒绝退款</el-button>
      </div>
    </el-dialog>
  </basic-container>
</template>

<script>
import { supplementList, reviewForRefund } from '@/api/member'
import { exportOrderList } from '@/services'
import { debounce, deepCopy } from '@/util/common'
import pagination from '@/util/mixins/pagination'
export default {
  mixins: [pagination],
  data () {
    return {
      refundNo: '', // 退款单号
      orderNo: '', // 订单编号
      userAccount: '', // 用户账户
      searchTime: '', // 时间
      searchStatus: '', // 开票状态1待开票 2已开票 3失败
      checkItem: {}, // 查看项
      refundRemark: '', // 备注
      showDetails: false // 详情弹窗
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    // 查看订单明细
    checkDetail (id) {
      this.$store.dispatch('app/setOrder', id)
      this.$router.push('/member/order')
    },
    // 打开弹窗
    openDetail (item, type) {
      this.checkItem = deepCopy(item)
      this.checkItem.detailType = type
      this.refundRemark = ''
      this.showDetails = true
    },
    // 获取列表
    getList () {
      this.listLoading = true
      let postData = {
        reviewCode: 11,
        refundOrderNo: this.refundNo,
        orderId: this.orderNo,
        mobile: this.userAccount,
        reviewTime: this.searchTime,
        refundReviewStatus: this.searchStatus,
        current: this.pageNo,
        size: this.pageSize
      }
      let onSuccess = res => {
        this.listLoading = false
        if (res.data.code === 200) {
          this.tableData = res.data.data.records
          this.totalEl = res.data.data.total
        } else {
          this.$message.error(res.data.msg)
        }
      }
      supplementList(postData).then(onSuccess).catch(() => { this.listLoading = false })
    },
    // 处理退款
    changeCheck: debounce(function (status) {
      if (!this.refundRemark && status === 3) {
        this.$message.error('请输入处理备注')
        return
      }
      reviewForRefund({
        content: this.refundRemark,
        bizRefrenceId: this.checkItem.orderId,
        status: status
      }).then(res => {
        this.listLoading = false
        if (res.data.code === 200) {
          this.showDetails = false
          this.getList()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }, 300, false),
    // 导出
    exportList () {
      let postData = {
        reviewCode: 11,
        refundOrderNo: this.refundNo,
        orderId: this.orderNo,
        mobile: this.userAccount,
        reviewTime: this.searchTime,
        refundReviewStatus: this.searchStatus
      }
      exportOrderList(postData)
    }
  }
}
</script>
